import React from 'react';
import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { HiOutlineArrowLeft, HiOutlineArrowRight } from 'react-icons/hi';
import { RiArrowDownSLine, RiArrowUpSLine } from 'react-icons/ri';
import { useParams } from 'react-router';
import { useHistory, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import TestBackground from '../../../assets/test/test_background.svg';
import useTestQuestions from '../../../hooks/useTestQuestions';
import useTestTime from '../../../hooks/useTestTime';
import {
	API_ENDPOINT,
	PROFILE_NAVIGATION_CTA,
	STRIDE_PROFILE_LINK,
} from '../../../utils/constants';
import {
	APIError,
	CurrentUserProfile,
	FetchResponse,
	QuestionAnswers,
} from '../../../utils/types';
import Button from '../../components/Button';
import CustomLoading from '../../components/CustomLoading';
import Flex from '../../components/Flex';
import Loading from '../../components/Loading';
import Navbar from '../../components/Navbar';
import SubmitTest from '../../components/popups/SubmitTest';
import TimeExcedded from '../../components/popups/TimeExcedded';
import Timer from '../../components/Timer';
import ErrorFallback from '.././ErrorFallback';
import CustModal from '.././quiz_pages/Intro/CustModal';

const succssful_img = require('../../../assets/Group 34421.png');

const AmuziStrideDefault = ({ testId, test }) => {
	const location = useLocation<CurrentUserProfile>();
	const history = useHistory();
	const { reportId } = useParams<{ reportId: string }>();
	const [reportLink, setReportLink] = useState<any>();
	const [showPrompt, setShowPrompt] = useState<boolean>(false);

	const [page, setPage] = useState<number>(1);
	const [openExplanations, setOpenExplanations] = useState<number[]>([]);

	const [answers, setAnswers] = useState<QuestionAnswers[]>([]);
	const [showSubmitConfirmation, setShowSubmitConfirmation] =
		useState<boolean>(false);
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [timeExcedded, setTimeExcedded] = useState<boolean>(false);

	const { data: questions, isLoading } = useTestQuestions(testId, page);

	const [isAppFlow, setIsAppFlow] = useState(false);

	const [time, setTime] = useState(test?.test_time);
	const timeArray =
		typeof time !== 'undefined' && time !== null && time.split(':');
	const [hours, setHours] = useState<number>(+timeArray[0]);
	const [minutes, setMinutes] = useState<number>(+timeArray[1]);
	const [seconds, setSeconds] = useState<number>(+timeArray[2]);
	const TestBackgroundImage = test?.test_configs?.header_background_image ?
		test?.test_configs?.header_background_image :
		TestBackground

	useEffect(() => {
		if (typeof time !== 'undefined' && time !== null) {
			let myInterval = setInterval(() => {
				if (seconds > 0) {
					setSeconds(seconds - 1);
				} else {
					if (minutes === 0) {
						if (hours === 0) {
							clearInterval(myInterval);
							setTimeExcedded(true);
						} else {
							setHours(hours - 1);
							setMinutes(59);
							setSeconds(59);
						}
					} else {
						setMinutes(minutes - 1);
						setSeconds(59);
					}
				}
			}, 1000);

			return () => {
				clearInterval(myInterval);
			};
		}
	});

	const getClass = () => {
		return hours === 0 ? (minutes < 5 ? 'blink' : '') : '';
	};

	useEffect(() => {
		window.onbeforeunload = null;
		// get params from query string
		const urlParams = new URLSearchParams(window.location.search);
		const flow = urlParams.get('flow');
		if (flow === 'app') {
			setIsAppFlow(true);
		}
	}, []);

	const retakeTest = () => {
		history.push({
			pathname: `/test/${testId}`,
			search: location.search,
		});
	};

	const handleOptionSelect = (id: number, answer: string) => {
		const index = getQuestionIndexInAnswers(id);

		const newAnswers = [...answers];
		index > -1 && newAnswers.splice(index, 1);
		newAnswers.push({ id, answer });
		setAnswers([...newAnswers]);
	};

	const getQuestionIndexInAnswers = (id: number) => {
		return answers.findIndex((answer) => {
			return answer.id === id;
		});
	};

	const allQuestionAnswered = () => {
		return questions?.questions?.every(
			(question) => getQuestionIndexInAnswers(question.id) >= 0,
		);
	};

	const toggleShowExplanation = (id: number) => {
		const index = openExplanations.indexOf(id);
		const newExplanations = [...openExplanations];
		index > -1 ? newExplanations.splice(index, 1) : newExplanations.push(id);
		setOpenExplanations([...newExplanations]);
	};

	const getSelectedAnswer = (id: number) => {
		const index = getQuestionIndexInAnswers(id);
		return answers[index];
	};

	const submitTest = async (): Promise<APIError[] | void> => {
		const urlSearchParams = new URLSearchParams(history.location.search);
		const redirectUrl = urlSearchParams.get('redirect_to');
		const testFlow = urlSearchParams.get('flow');
		try {
			const postData = {
				report_id: reportId,
				response: [...answers],
			};
			let url = new URL(`${API_ENDPOINT}questions/${testId}`);
			url.search = urlSearchParams.toString();
			const { data: response } = await axios.post<
				FetchResponse<{ report_link: string }>
			>(
				url.href,
				postData,
			);
			setShowSubmitConfirmation(false);
			if (testFlow === 'app') {
				setIsModalOpen(true);
				setReportLink(response.data.report_link);
			} else {
				if (redirectUrl) {
					document.location.href = redirectUrl;
				} else {
					if (response.data.report_link) {
						window.open(response.data.report_link, '_self');
					}
				}
			}
		} catch (error) {
			const errors = error?.response?.message;
			return errors;
		}
	};

	const renderQuestions = () => {
		return (
			<QuestionContainer column>
				{questions?.questions?.map(
					({ id, question, alternate_phrase, options }, index) => {
						return (
							<QuestionCard test={test} column key={`${id}-${index}`}>
								<QuestionCount>{`Question ${index + 1 + (page - 1) * questions?.pagination_data?.page_size
									}`}</QuestionCount>
								<Flex style={{ marginBottom: '1rem' }}>
									<Question>
										<div
											dangerouslySetInnerHTML={{ __html: question }}
										></div>{' '}
									</Question>
									{(alternate_phrase ||
										options.filter((option) => option.alternate.length > 0)
											.length > 0) && (
											<ExplanationButton
												onClick={() => toggleShowExplanation(id)}
											>
												Explanation
												{openExplanations.indexOf(id) > -1 ? (
													<RiArrowUpSLine />
												) : (
													<RiArrowDownSLine />
												)}
											</ExplanationButton>
										)}
								</Flex>
								{alternate_phrase && (
									<Explanation hidden={openExplanations.indexOf(id) < 0}>
										{alternate_phrase}
									</Explanation>
								)}
								{options.map(({ label, trait, alternate }, index) => {
									return (
										<OptionContainer
											test={test}
											key={`${id}-${trait}-${index}`}
											selected={getSelectedAnswer(id)?.answer === label}
										>
											<QuestionLabel>
												<Option test={test}
													type='radio'
													value={label}
													id={`${id}-${trait}`}
													name={`${id}`}
													onChange={() => handleOptionSelect(id, label)}
													required
													checked={getSelectedAnswer(id)?.answer === label}
												/>

												<span>
													{label}
													{alternate && openExplanations.indexOf(id) >= 0 && (
														<AnswerExplanation>
															({alternate}){' '}
														</AnswerExplanation>
													)}
												</span>
											</QuestionLabel>
										</OptionContainer>
									);
								})}
							</QuestionCard>
						);
					},
				)}
			</QuestionContainer>
		);
	};

	const getProgress = () => {
		const pagination = questions?.pagination_data;
		return pagination && pagination.page_elements
			? Math.round((answers.length * 100) / pagination?.page_elements)
			: 0;
	};

	const renderTestDetail = () => {
		return (
			<TestName>
				<img src={TestBackgroundImage} alt='Background' />
				<div>
					{test?.test_display_label
						? test?.test_display_label
						: test?.test_name}
				</div>
			</TestName>
		);
	};

	const renderProgress = () => {
		if (questions?.pagination_data?.page_no) {
			const pages = Math.ceil(
				questions?.pagination_data?.page_elements
					? questions?.pagination_data?.page_elements /
					questions?.pagination_data?.page_size
					: 1,
			);
			var foo: number[] = [];

			for (var i = 1; i <= pages; i++) {
				foo.push(i);
			}
			return foo;
		}
	};

	const renderFooter = () => {
		return (
			<Footer>
				<GoBackContainer>
					<GoBackButton
						disabled={!questions?.pagination_data?.page_previous}
						onClick={() => setPage(page - 1)}
					>
						<HiOutlineArrowLeft />
						Go Back
					</GoBackButton>
				</GoBackContainer>
				<ProgressContainer>
					<ProgressDiv test={test}>{getProgress()} %</ProgressDiv>
				</ProgressContainer>
				<ContinueContainer>
					{questions?.pagination_data?.page_next ? (
						<ContinueButton
							test={test}
							disabled={!allQuestionAnswered()}
							onClick={() => setPage(page + 1)}
						>
							Continue <HiOutlineArrowRight />
						</ContinueButton>
					) : (
						<ContinueButton
							test={test}
							disabled={!allQuestionAnswered()}
							onClick={() => setShowSubmitConfirmation(true)}
						>
							Submit Test
							<HiOutlineArrowRight />
						</ContinueButton>
					)}
				</ContinueContainer>
			</Footer>
		);
	};

	useEffect(() => {
		if (!location.state.name) {
			history.push({
				pathname: `/test/${testId}`,
				search: location.search,
			});
		}
		if (timeExcedded && test?.auto_submit) {
			submitTest();
		}
	}, [location, answers, time, timeExcedded]);

	if (!isLoading) {
		const customLogo = test?.logo_image;
		return questions?.questions ? (
			<Fragment>
				<Navbar
					homepage='https://strideahead.in'
					customLogo={customLogo}
					authenticate={false}
				/>
				<Container column>
					{time?.time_remaining && (
						<TimerContainer>
							<Timer
								key={time?.time_remaining}
								time={time?.time_remaining}
								onCompletion={() => setTimeExcedded(true)}
							/>
						</TimerContainer>
					)}
					{renderTestDetail()}
					{renderQuestions()}
					<Progress>
						{renderProgress()?.map((page, index) => {
							return (
								<ProgressBar test={test}
									key={index}
									completed={
										questions && page <= questions?.pagination_data?.page_no
									}
								/>
							);
						})}
					</Progress>
					{renderFooter()}
				</Container>
				{showSubmitConfirmation && (
					<SubmitTest
						test={test}
						onClose={() => setShowSubmitConfirmation(false)}
						onSubmit={() => submitTest()}
					/>
				)}
				{isModalOpen && (
					<CustModal
						hideCloseButton={true}
						open={isModalOpen}
						onClose={() => setIsModalOpen(false)}
					>
						<div className='pop_box_sucessfull_container'>
							<div className='sucessfull_img_container'>
								<img
									src={succssful_img.default}
									alt='sucessfull_img_'
									className='sucessfull_img_self'
								/>
							</div>

							<h2 className='test_completed_text'>Test Completed</h2>
							<p className='text_succes_extra_content'>
								Your report is being generated, and will be ready shortly
							</p>
							<div
								className='success-btn-wrapper'
								style={{ justifyContent: 'center', gap: '15px' }}
							>
								<button
									className='done_btn'
									onClick={() => {
										setIsModalOpen(false);
										window.location.replace(`${reportLink}`);
									}}
								>
									VIEW REPORT
								</button>
								{isAppFlow && (
									<button
										className='profile_navigation_btn'
										onClick={() => {
											setIsModalOpen(false);
											window.location.replace(`${STRIDE_PROFILE_LINK}`);
										}}
									>
										{PROFILE_NAVIGATION_CTA}
									</button>
								)}
							</div>
						</div>
					</CustModal>
				)}
				{timeExcedded &&
					(test?.auto_submit ? (
						<Loading message='Submitting your Test. Please wait...' />
					) : (
						<TimeExcedded onClick={() => retakeTest()} />
					))}
			</Fragment>
		) : (
			<ErrorFallback error='500' showNavbar={false} />
		);
	} else {
		return <>{<CustomLoading />}</>;
	}
};

export default AmuziStrideDefault;

const Container = styled(Flex)`
	width: 100%;
	background-color: ${(props) => props.theme.colors.white};
	height: auto;
	margin: 0px auto;
`;

const TestName = styled(Flex)`
	position: relative;
	width: 80%;
	margin: 0px auto;
	margin-top: 5rem;
	font-weight: 500;
	font-size: 3.4rem;
	align-items: center;

	img {
		width: 100%;
		object-fit: cover;
		height: 100%;
	}

	div {
		position: absolute;
		margin: 0rem 4rem;
		color: ${(props) => props.theme.colors.white};
	}

	@media only screen and (max-width: 1024px) {
		width: 90%;
		margin-top: 1rem;
		font-size: 1.8rem;
		padding: 1rem 0;
		background-image: url(${TestBackground
	});
		height: 6rem;
		background-repeat: no-repeat;
		background-size: cover;
		border-radius: 4px;
		img {
			display: none;
		}
		div {
			margin: 0rem 1rem;
		}
	}
`;

const Footer = styled(Flex)`
	position: fixed;
	bottom: 0;
	width: 100%;
	height: 6.8rem;
	background: ${(props) => props.theme.colors.white};
	@media only screen and (max-width: 1024px) {
		height: 5rem;
	}
`;

const GoBackContainer = styled(Flex)`
	width: 20rem;
	flex: 1;
	background: none;
	border: 0px;
	color: ${(props) => props.theme.colors.grey[500]};
`;

const GoBackButton = styled(Button)`
	color: ${(props) => props.theme.colors.grey[500]};
	width: 20rem;
	height: 5rem;
	margin: auto 2rem;
	background-color: ${(props) => props.theme.colors.white};
	font-weight: 600;
	font-size: 1.6rem;
	line-height: 150%;
	border: 0px;
	svg {
		vertical-align: middle;
		width: 25px;
		font-weight: bold;
		margin-right: 10px;
	}

	@media only screen and (max-width: 1024px) {
		margin: auto 1rem;
		width: max-content;
		text-align: left;
		font-size: 1.2rem;
	}
`;

const ProgressContainer = styled(Flex)`
	width: 20rem;
	flex: 1;
	color: ${(props) => props.theme.colors.blue[500]};
`;

const ProgressBar = styled(Flex) <{ completed?: boolean, test?: any }>`
	height: 0.5rem;
	width: 100%;
	background-color: ${(props) => props.theme.colors.blue[200]};

	${({ completed, test, theme }) =>
		completed &&
		css`
			background-color: ${() =>
				test?.test_configs?.theme?.bg_color ||
				theme.colors.blue[500]};
		`}
	border-right: 2px solid ${(props) => props.theme.colors.red[100]};
`;

const ProgressDiv = styled(Flex)`
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	color: ${(props) => props.theme.colors.grey[500]};
	margin: auto;
`;

const ContinueContainer = styled(Flex)`
	width: 20rem;
	float: right;
	flex: 1;
	flex-direction: row-reverse;
`;

const ContinueButton = styled(Button)`
  width: 20rem;
  height: 5rem;
  background-color : ${(props) => props.test?.test_configs?.theme?.bg_color ||
		props.theme.colors.blue[500]};
  color : ${(props) => props.theme.colors.white};
  margin auto 2rem;
  svg{
    vertical-align: bottom;
    width: 25px;
    font-weight: bold;
    margin-left: 10px;
  }

  @media only screen and (max-width: 1024px) {
    margin: auto 1rem;
    text-align: right;
    width: max-content;
    padding: 1rem;
    height: auto;
    font-size: 1.2rem;
  }
`;

const Progress = styled(Flex)`
	flex: 1;
	position: fixed;
	bottom: 6.9rem;
	width: 100%;
`;

const QuestionContainer = styled(Flex)`
	width: 80%;
	height: 100%;
	margin: auto;
	margin-top: 5rem;
	margin-bottom: 9rem;
	@media only screen and (max-width: 1024px) {
		width: 90%;
		margin-top: 1rem;
	}
`;

const QuestionCard = styled(Flex)`
	padding: 2rem;
	border-left: 5px solid ${(props) => props.theme.colors.white};
	&:hover {
		border-left: 5px solid ${(props) => props.test?.test_configs?.theme?.bg_color ||
		props.theme.colors.blue[500]};
		border-radius: 2px;
		box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.05);
	}
`;

const QuestionCount = styled(Flex)`
	font-weight: normal;
	font-size: 1.4rem;
	line-height: 195%;
	color: ${(props) => props.theme.colors.grey[400]};
	@media only screen and (max-width: 1024px) {
		font-size: 1.2rem;
	}
`;

const Question = styled(Flex)`
	font-weight: 600;
	font-size: 2.6rem;
	line-height: 100%;
	color: ${(props) => props.theme.colors.grey[600]};
	flex: 1;
	align-items: center;
	-webkit-user-select: none;
	-webkit-touch-callout: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	@media only screen and (max-width: 1024px) {
		font-size: 1.8rem;
		margin-bottom: 0;
	}
`;

const Explanation = styled(Flex) <{ hidden?: boolean }>`
	font-size: 2rem;
	font-weight: 500;
	line-height: 100%;
	margin-bottom: 2.5rem;
	flex: 1;
	color: ${(props) => props.theme.colors.green[600]};
	${({ hidden }) =>
		hidden &&
		css`
			display: none;
		`}

	@media only screen and (max-width: 1024px) {
		font-size: 1.2rem;
		margin-bottom: 1rem;
	}
`;

const AnswerExplanation = styled.div`
	font-size: 16px;
	line-height: 19px;
	margin-left: 1rem;
	color: ${(props) => props.theme.colors.green[600]};
	@media only screen and (max-width: 1024px) {
		margin-left: 0;
		font-size: 1.4rem;
		margin-top: 0.5rem;
	}
`;

const ExplanationButton = styled(Button)`
  width: max-content;
  height: auto;
  background: rgba(64, 123, 255, 0.22);
  border-radius: 4px;
  color: ${(props) => props.theme.colors.blue[500]};
  border: 0px;
  font-size: 1.6rem
  line-height: 150%;
  svg{
    vertical-align: middle;
    font-size: 2rem;
  }
  padding: 1.2rem;
  @media only screen and (max-width: 1024px) {
    font-size: 1.2rem;
    padding: .5rem 1rem;
    svg{
      font-size: 1.5rem;
    }
  }
`;

const OptionContainer = styled(Flex) <{ selected?: boolean, test?: any }>`
	border: 1px solid ${(props) => props.theme.colors.grey[200]};
	box-sizing: border-box;
	border-radius: 5px;
	background: #fff;
	margin-bottom: 1rem;
  	padding : 10px;
	${({ selected, test, theme }) =>
		selected &&
		css`
			border-color: ${() => test?.test_configs?.theme?.bg_color ||
				theme.colors.green[400]};
			label {
				color: ${() => test?.test_configs?.theme?.primary_color ||
				theme.colors.green[400]};
			}
			input {
				border-color: ${() =>
				test?.test_configs?.theme?.bg_color ||
				theme.colors.green[400]};
				background: ${() =>
				test?.test_configs?.theme?.bg_color ||
				theme.colors.green[400]};
			}
		`}
`;
const Option = styled.input<{ test?: any }>`
	width: 15px;
	height: 15px;
	&:checked {
		color: ${(props) => props.test?.test_configs?.theme?.bg_color ||
		props.theme.colors.green[500]};
	}
`;

const QuestionLabel = styled.label`
	font-weight: normal;
	font-size: 16px;
	line-height: 19px;
	margin-left: 1rem;
	color: ${(props) => props.theme.colors.grey[500]};
	width: 100%;
	cursor: pointer;
	flex-direction: row;
	display: flex;
	span {
		margin-left: 1rem;
		display: inherit;
	}

	@media only screen and (max-width: 1024px) {
		span {
			margin-left: 1rem;
			display: block;
		}
	}
`;

const TimerContainer = styled(Flex)`
	width: 100%;
	font-size: 1.6rem;
	color: ${(props) => props.theme.colors.white};
	background: ${(props) => props.theme.colors.green[600]};
	padding: 0.8rem 0;
	position: sticky;
	top: 6rem;
	z-index: 1;
	div {
		margin: auto;
	}

	@media only screen and (max-width: 1024px) {
		font-size: 1.2rem;
	}
`;
